export const createQuerySummaryCards = (
  sites,
  assets,
  fromDate,
  toDate,
  products
) => {
  let query = `from=${fromDate}&to=${toDate}`
  products.forEach((product) => {
    query += `&productType=${product}`
  })
  if (sites.length > 0) {
    sites.forEach((site) => {
      query += `&sitesIds=${site.id}`
    })
  }
  if (assets.length > 0) {
    assets.forEach((asset) => {
      query += `&assetsIds=${asset.id}`
    })
  }
  return query
}

export const createQueryForExport = (query, localDate) => {
  return `${query}&localDate=${localDate}`
}

export const makeQueryApiAssetsSites = (list, queryParamName) => {
  const amp = '&'
  let newQuery = ''

  list.forEach((item, index) => {
    const itemId = item.id
    newQuery += `${queryParamName}=${itemId}${
      index === list.length - 1 ? '' : amp
    }`
  })

  return newQuery
}

export const getTextCardSummaryColor = (typeProduct) => {
  let color = ''

  switch (typeProduct) {
    case 'Oil':
      color = '#bb68b3'
      break
    case 'Water':
      color = '#50c7c0'
      break

    case 'Gas':
      color = '#ffc107'
      break

    default:
      color = '#000000'
      break
  }

  return color
}

export const checkForOnlySpacesString = (text) => {
  let result = false
  const validation = !text.replace(/\s/g, '').length && text !== ''
  if (validation) {
    result = true
  }
  return result
}
